document.addEventListener('DOMContentLoaded', () => {
  const pageLoader = document.querySelector('.page-loader');

  if (pageLoader !== null) {
    setTimeout(function () {
      pageLoader.classList.add('loaded');
      window.dispatchEvent(new Event('resize'));
    }, 1000);
  
    setTimeout(function () {
      pageLoader.classList.add('ending');
      window.dispatchEvent(new Event('resize'));
    }, 1600);
  }
})



window.ameliaActions = { 
  beforeBooking: function (success = null, error = null, data) {
    if (data.type == 'event') {
      success()
      return
    }
    if (data.type !== 'package' && data.service.id === 1) data.location.address = 'via Telefon'
    if (data.type !== 'package' && data.service.name.toLowerCase().includes('online')) data.location.address = 'via Zoom'
    // call success callback for the booking to be completed
    success()
  }
}
